import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { PerkDocument } from "@tiicker/util/lib/contentful/types";
import Button from "components/core/Button/Button";
import { Entry } from "contentful";
import React, { useState } from "react";
import styles from "./CurrentPerkOfTheWeek.module.scss";
import * as DateIso from "@tiicker/util/lib/date-iso";
import PerkMegaModal from "../PerkMegaModal/PerkMegaModal";

type Props = {
  perk: Entry<PerkDocument>;
  includes: any;
};

const CurrentPerkOfTheWeek = (props: Props) => {
  const [showPerkModal, setShowPerkModal] = useState<boolean>(false);

  const image = getImageReference(props.perk.fields.image, props.includes);

  const brandLogo = getImageReference(
    props.perk.fields.brand.fields.companyLogoDark,
    props.includes
  );

  const qualificationType = props.perk.fields.qualificationType;
  const qualificationText =
    qualificationType === "Shares" || !qualificationType
      ? "Shares Required"
      : qualificationType === "ShareValue"
      ? "Holding Value Required"
      : "Portfolio Value Required";
  const qualificationValue =
    qualificationType === "Shares" || !qualificationType
      ? props.perk.fields.numberOfSharesRequired
      : qualificationType === "ShareValue"
      ? props.perk.fields.shareDollarValue
      : props.perk.fields.totalPortfolioValue;

  const requirementDate = DateIso.formatLongMonthDayYear(
    DateIso.weeksAgo(props.perk.fields.numberOfWeeksHeldRequired)
  );
  const requirementText =
    props.perk.fields.numberOfWeeksHeldRequired === 0
      ? "No Requirement"
      : `${props.perk.fields.numberOfWeeksHeldRequired} week${
          props.perk.fields.numberOfWeeksHeldRequired === 1 ? "" : "s"
        }`;

  return (
    <div className={styles.container}>
      {image && <img src={image.fields.file.url} className={styles.image} />}
      <div className={styles.detailContainer}>
        <div>
          {brandLogo && (
            <img
              draggable={false}
              className={styles.brandLogo}
              src={brandLogo.fields.file.url}
            />
          )}
          <h5 className={styles.cardTitle}>{props.perk.fields.title}</h5>
          <p className={styles.description}>{props.perk.fields.description}</p>

          <div className={styles.detailSection}>
            <div>
              <p className={styles.label}>{qualificationText}</p>
              <p className={styles.detail}>{qualificationValue}</p>
            </div>
            <div>
              <p className={styles.label}>Hold For</p>
              <p className={styles.detail}>{requirementText}</p>
            </div>
          </div>
        </div>
        <Button
          type="primary"
          arrow
          className={styles.button}
          onClick={() => setShowPerkModal(true)}
        >
          View Details
        </Button>
      </div>
      <PerkMegaModal
        perkId={props.perk.sys.id}
        isOpen={showPerkModal}
        onClose={() => setShowPerkModal(false)}
        ticker={props.perk.fields.brand.fields.tickerSymbol}
      />
    </div>
  );
};

export default CurrentPerkOfTheWeek;
